import React from 'react';
import { cx } from '../cx';

// D-09 §15.18 — Filter Chip (.fchip[.active] > .cnt 카운트)
export interface FilterChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  count?: number;
  size?: 'sm' | 'md' | 'lg';
}

export function FilterChip({ active, count, size = 'md', className = '', children, ...props }: FilterChipProps) {
  return (
    <button
      type="button"
      className={cx('fchip', active && 'active', size !== 'md' && `fchip-${size}`, className)}
      {...props}
    >
      {children}
      {count != null && <span className="cnt">{count}</span>}
    </button>
  );
}
